import React from 'react';
import { FaPhoneVolume, FaLocationDot } from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
import mixpanel from 'mixpanel-browser';
import {
  CAREER_EMAIL_ADDRESS,
  CAREER_ADDRESS_1,
  CAREER_ADDRESS_2,
  CAREER_PHONE,
  CAREER_CONTACT_HEADER,
  CAREER_CONTACT_SUBHEADER,
  CASHCLEVER_GOOGLE_MAP_URL,
} from '../../constants/Careers/index';

import Placeholder from './CareerPlaceholder.png';

import './CareerContact.css';

export const CareerContact = () => {
  const handleTrackLinkClick = (method) => {
    mixpanel.track('Career Contact Us', {
      ContactUsMethod: method,
    });
  };

  return (
    <div id="contact-us-career-container" className="contact-container">
      <div className="contact-content">
        <h1 className="contact-header">{CAREER_CONTACT_HEADER}</h1>
        <div>
          <h5 className="contact-sub-header">{CAREER_CONTACT_SUBHEADER}</h5>
        </div>
        <div className="contact-group">
          <div className="contact-pair">
            <FaPhoneVolume size={22} className="contact-icon" />
            <a
              className="contact-text"
              href={`tel:${CAREER_PHONE}`}
              onClick={() => handleTrackLinkClick(CAREER_PHONE)}
            >
              {CAREER_PHONE}
            </a>
          </div>
          <div className="contact-pair">
            <MdEmail size={22} className="contact-icon" />
            <a
              className="contact-text"
              href={`mailto:${CAREER_EMAIL_ADDRESS}`}
              onClick={() => handleTrackLinkClick(CAREER_EMAIL_ADDRESS)}
            >
              {CAREER_EMAIL_ADDRESS}
            </a>
          </div>
          <div className="contact-pair">
            <FaLocationDot size={22} className="contact-icon" />
            <a
              classname="address-pair"
              href={`${CASHCLEVER_GOOGLE_MAP_URL}`}
              onClick={() => handleTrackLinkClick('Google Map')}
            >
              <div className="contact-text">{CAREER_ADDRESS_1}</div>
              <div className="contact-text">{CAREER_ADDRESS_2}</div>
            </a>
          </div>
        </div>
      </div>
      <img className="contact-image" src={Placeholder} alt="placeholder-image" />
    </div>
  );
};
